function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  fill: "#009545",
  fillRule: "evenodd"
}, React.createElement("path", {
  d: "M40.025 30.746l-6.33-10.876a1.032 1.032 0 0 0-1.402-.373c-.492.282-.66.905-.376 1.392l6.33 10.876c.304.522.388 1.001.225 1.281s-.623.448-1.231.448H25.57v-2.182c0-.69-.403-.855-.894-.367l-2.703 2.681a1.25 1.25 0 0 0 0 1.773l2.703 2.681c.491.488.893.323.893-.367v-2.182h11.67c1.371 0 2.468-.534 3.01-1.466.543-.932.46-2.141-.225-3.319M21.95 3.303l5.114 8.916-1.924 1.118c-.608.354-.55.792.127.975l3.728 1.005a1.28 1.28 0 0 0 1.563-.908l1-3.753c.181-.683-.167-.952-.775-.599l-1.924 1.118-5.113-8.916C23.054 1.053 22.03.361 20.935.361s-2.12.692-2.812 1.898l-6.378 11.123c-.287.5-.117 1.138.38 1.426a1.035 1.035 0 0 0 1.416-.382l6.378-11.123c.307-.535.686-.855 1.016-.855.329 0 .709.32 1.016.855M15.532 33.244H4.125c-.636 0-1.117-.174-1.288-.465-.17-.292-.082-.79.238-1.337l5.114-8.834 1.999 1.124c.631.355.99.08.8-.611L9.931 19.32a1.328 1.328 0 0 0-1.624-.913l-3.857 1.039c-.7.189-.758.634-.126.989l1.999 1.124-5.112 8.83c-.716 1.223-.802 2.48-.235 3.448.567.968 1.715 1.524 3.148 1.524h11.407c.593 0 1.074-.474 1.074-1.059 0-.584-.481-1.058-1.074-1.058"
}));

var SvgRecycleIcon = function SvgRecycleIcon(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 41,
    height: 39,
    viewBox: "0 0 41 39",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgRecycleIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/recycle-icon.03212075.svg";
export { ForwardRef as ReactComponent };